export default "__VITE_ASSET__5UIzPzxA__"